// employee/reducers.ts
const initialState = {
    getSalesData: [],
    getSalesCount: null,
    getSalesNo: null,
    createSalesData: null,
    updateSalesData: null,
    getSalesMetaMessage: null,
    getSalesNoSuccess: false,
    getSalesNoFailure: false,
    getSalesSuccess: false,
    getSalesFailure: false,
    createSalesSuccess: false,
    createSalesFailure: false,
    updateSalesSuccess: false,
    updateSalesFailure: false,
    deleteSalesSuccess: false,
    deleteSalesFailure: false,
};

export default function SalesReducer(state = initialState, action: any) {
    switch (action.type) {
        case 'GET_SALES_SUCCESS': {
            return {
                ...state,
                getSalesSuccess: true,
                getSalesData: action.payload?.data?.data?.data,
                getSalesCount: action.payload?.data?.data?.meta?.total,
                getSalesFailure: false,
            };
        }
        case 'GET_SALES_FAILURE': {
            return {
                ...state,
                getSalesFailure: true,
                getSalesMetaMessage: action.payload?.data?.data?.meta?.message,
                getSalesSuccess: false,
            };
        }
        case 'RESET_GET_SALES': {
            return {
                ...state,
                getSalesSuccess: false,
                getSalesFailure: false,
                getSalesData: [],
                getSalesMetaMessage: null,
            };
        }

        case 'GET_SALES_NO_SUCCESS': {
            return {
                ...state,
                getSalesNoSuccess: true,
                getSalesNo: (parseInt(action.payload?.data?.data?.data) + 1).toString(),
                getSalesNoFailure: false,
            };
        }

        case 'GET_SALES_NO_FAILURE': {
            return {
                ...state,
                getSalesNoSuccess: false,
                getSalesNoFailure: true,
            };
        }

        case 'RESET_GET_SALES_NO': {
            return {
                ...state,
                getSalesNoSuccess: false,
                getSalesNo: null,
                getSalesNoFailure: false,
                getSalesMetaMessage: null,
            };
        }

        case 'CREATE_SALES_SUCCESS': {
            return {
                ...state,
                createSalesSuccess: true,
                createSalesData: action.payload?.data?.data?.data,
                getSalesMetaMessage: action.payload?.data?.data?.meta?.message,
                createSalesFailure: false,
            };
        }
        case 'CREATE_SALES_FAILURE': {
            return {
                ...state,
                createSalesFailure: true,
                getSalesMetaMessage: action.payload?.data?.data?.meta?.message,
                createSalesSuccess: false,
            };
        }
        case 'RESET_CREATE_SALES': {
            return {
                ...state,
                createSalesSuccess: false,
                createSalesFailure: false,
                createSalesData: null,
                getSalesMetaMessage: null,
            };
        }

        case 'UPDATE_SALES_SUCCESS': {
            return {
                ...state,
                updateSalesSuccess: true,
                updateSalesData: action.payload?.data?.data?.data,
                getSalesMetaMessage: action.payload?.data?.data?.meta?.message,
                updateSalesFailure: false,
            };
        }
        case 'UPDATE_SALES_FAILURE': {
            return {
                ...state,
                updateSalesFailure: true,
                getSalesMetaMessage: action.payload?.data?.data?.meta?.message,
                updateSalesSuccess: false,
            };
        }
        case 'RESET_UPDATE_SALES': {
            return {
                ...state,
                updateSalesSuccess: false,
                updateSalesFailure: false,
                updateSalesData: null,
                getSalesMetaMessage: null,
            };
        }

        case 'DELETE_SALES_SUCCESS': {
            return {
                ...state,
                deleteSalesSuccess: true,
                getSalesMetaMessage: action.payload?.data?.data?.meta?.message,
                deleteSalesFailure: false,
            };
        }
        case 'DELETE_SALES_FAILURE': {
            return {
                ...state,
                deleteSalesFailure: true,
                getSalesMetaMessage: action.payload?.data?.data?.meta?.message,
                deleteSalesSuccess: false,
            };
        }
        case 'RESET_DELETE_SALES': {
            return {
                ...state,
                deleteSalesSuccess: false,
                deleteSalesFailure: false,
                getSalesMetaMessage: null,
            };
        }

        default: {
            return state;
        }
    }
}
